const platforms = [
  {
    key: 'x_handle',
    url: (h) => `https://x.com/${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    key: 'instagram_handle',
    url: (h) => `https://instagram.com/${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    key: 'tiktok_handle',
    url: (h) => `https://tiktok.com/@${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.18 8.18 0 004.77 1.52V6.84a4.84 4.84 0 01-1-.15z" />
      </svg>
    ),
  },
  {
    key: 'youtube_handle',
    url: (h) => `https://youtube.com/@${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    key: 'snapchat_handle',
    url: (h) => `https://snapchat.com/add/${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301a.602.602 0 01.257-.057c.21 0 .39.09.495.18a.606.606 0 01.21.465c0 .39-.375.63-.51.72-.39.27-.855.42-1.17.51-.195.06-.315.12-.345.195-.015.06-.03.12-.015.21.015.045.075.195.165.42.18.42.51 1.065.84 1.545.48.705 1.095 1.14 1.425 1.335.165.09.285.18.285.33 0 .075-.015.15-.06.225-.18.39-.69.585-1.29.72-.12.03-.21.06-.3.105-.18.09-.21.21-.24.375 0 .06-.015.135-.03.21-.03.15-.135.315-.54.315a2.29 2.29 0 01-.585-.105 5.49 5.49 0 00-1.29-.21c-.21 0-.42.015-.615.06-.57.135-.885.42-1.245.78-.465.465-.975.975-2.055.975-.03 0-.06 0-.09-.015h-.06c-1.08 0-1.59-.51-2.055-.975-.36-.36-.675-.645-1.245-.78a3.36 3.36 0 00-.615-.06c-.42 0-.87.075-1.29.21a2.34 2.34 0 01-.585.105c-.39 0-.51-.15-.54-.315a1.64 1.64 0 01-.03-.21c-.03-.165-.06-.285-.24-.375-.09-.045-.195-.075-.3-.105-.6-.135-1.11-.33-1.29-.72a.555.555 0 01-.06-.225c0-.15.12-.24.285-.33.33-.195.945-.63 1.425-1.335.33-.48.66-1.125.84-1.545.09-.225.15-.375.165-.42.015-.09 0-.15-.015-.21-.03-.075-.15-.135-.345-.195a4.94 4.94 0 01-1.17-.51c-.135-.09-.51-.33-.51-.72a.606.606 0 01.21-.465c.105-.09.285-.18.495-.18a.6.6 0 01.257.057c.375.18.735.3 1.035.3.195 0 .33-.045.4-.09-.007-.165-.02-.33-.03-.51l-.004-.06c-.104-1.628-.23-3.654.3-4.847C7.447 1.07 10.806.793 11.796.793h.41z" />
      </svg>
    ),
  },
  {
    key: 'threads_handle',
    url: (h) => `https://threads.net/@${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.343-.783-.932-1.407-1.707-1.808-.29 1.61-.86 2.836-1.71 3.655-1.12 1.076-2.67 1.622-4.61 1.622-.05 0-.1 0-.149-.002-1.453-.038-2.703-.503-3.62-1.346-.947-.87-1.468-2.042-1.468-3.301 0-1.26.494-2.342 1.43-3.132.895-.755 2.114-1.175 3.53-1.216 1.16-.034 2.21.138 3.13.508.026-.652.009-1.312-.054-1.964-.123-1.265-.55-2.2-1.272-2.776-.777-.622-1.907-.94-3.357-.94h-.033c-1.178.012-2.148.303-2.883.864l-1.205-1.675C8.31 2.32 9.627 1.905 11.18 1.885h.042c1.874 0 3.397.477 4.53 1.42 1.155.96 1.81 2.355 1.95 4.142.075.954.07 1.933-.014 2.917.476.258.905.573 1.278.948 1.074 1.08 1.573 2.548 1.443 4.249-.18 2.378-1.2 4.3-3.032 5.712C15.654 22.558 13.565 23.18 12.186 24zm-.09-10.678c-1.04 0-2.002.312-2.63.855-.568.49-.855 1.128-.855 1.898 0 .758.283 1.393.842 1.888.59.525 1.442.81 2.467.833 1.502-.04 2.643-.39 3.392-1.042.555-.484.945-1.17 1.164-2.046-.802-.46-1.84-.655-2.848-.655-.178 0-.356.008-.531.023l-.001.046z" />
      </svg>
    ),
  },
  {
    key: 'facebook_handle',
    url: (h) => `https://facebook.com/${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    key: 'venmo_handle',
    url: (h) => `https://venmo.com/${h}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M19.89 1.15c.67 1.1 1.11 2.24 1.11 3.65 0 4.55-3.89 10.46-7.04 14.62H7.58L4.11 1.89l5.74-.52 1.86 14.88c1.72-2.82 3.86-7.27 3.86-10.31 0-1.33-.24-2.24-.61-2.95l4.93-1.84z" />
      </svg>
    ),
  },
]

export default function SocialLinks({ user }) {
  const links = platforms.filter((p) => user?.[p.key])
  if (links.length === 0) return null

  return (
    <div className="flex items-center gap-2">
      {links.map((p) => (
        <a
          key={p.key}
          href={p.url(user[p.key])}
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-muted hover:text-text-secondary transition-colors"
        >
          {p.icon}
        </a>
      ))}
    </div>
  )
}
